import { render, staticRenderFns } from "./IssueCreatedByStatistics.vue?vue&type=template&id=c59c8638&scoped=true&"
import script from "./IssueCreatedByStatistics.vue?vue&type=script&lang=js&"
export * from "./IssueCreatedByStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59c8638",
  null
  
)

export default component.exports